export default __webpack_public_path__ + "static/media/glogix-logo-dark.67d31517.png";